/**
 * usePrompts — manages prompt list and selected prompt.
 */
import { useState, useEffect } from 'react';
import { getPrompts } from '../lib/api';

export interface UsePromptsReturn {
  prompts: string[];
  selectedPrompt: string;
  setSelectedPrompt: (prompt: string) => void;
}

export function usePrompts(): UsePromptsReturn {
  const [prompts, setPrompts] = useState<string[]>([]);
  const [selectedPrompt, setSelectedPrompt] = useState('');

  useEffect(() => {
    getPrompts()
      .then(data => {
        setPrompts(data.prompts);
        // Don't auto-select — let user pick (placeholder shown until selection)
      })
      .catch(() => {
        const fallback = ['Is there a chimpanzee?', 'Is a person running?', 'Is there a vehicle?'];
        setPrompts(fallback);
        // Don't auto-select fallback either
      });
  }, []);

  return {
    prompts,
    selectedPrompt,
    setSelectedPrompt,
  };
}
